import {
  LandingInfo_AuthRequest as AuthRequest,
  LandingInfo,
} from '@protos/apps/pc/landing_info_pb'

export const getAuthRequest = (payload?: LandingInfo['landingState']) => {
  return payload?.case === 'authRequest' ? payload.value : null
}

export const getAuthSession = (payload?: LandingInfo['landingState']) => {
  return payload?.case === 'authInfo' ? payload.value.authSession : null
}

export const getAuthStatus = (payload?: AuthRequest['authState']) => {
  return payload?.case === 'authStatus' ? payload.value : null
}

export const getAuthOptions = (payload?: AuthRequest['authState']) => {
  return payload?.case === 'authOptions' ? payload.value : null
}

export const getLandingErrorCode = (payload?: LandingInfo['landingState']) => {
  return payload?.case === 'landingErrorInfo' ? payload.value : null
}
